












































































export default {
  props: ["resultData"],
  data() {
    return {
      loading: false
    };
  },
  components: {},
  /*
  watch: {
    compLoaded: function (val, oldVal) {
      this.the_task = null
    },
  },
  */
  computed: {
    firstImage() {
      if (this.resultData._attachments) {
        let keys = Object.keys(this.resultData._attachments);

        for (let k of keys) {
    

          return "data:image/png;base64,"+this.resultData._attachments[k].data
        }

/*
        keys.forEach(key => {
          let item = this.resultData._attachments[key];
   
          //...work with item

          console.log("jo", item.data)
          return item.data
        })
*/
       
      }
    }
  },
  mounted() {},
  destroyed() {},
  methods: {
    editResult(item) {
      console.log("hallo")
      this.$emit("resultEdit", item);
    }
  }
};
